import * as Yup from "yup";

import { VerizonLoginKeys } from "../../../../constant/verizonLogin";

export const verizonLoginValidationSchema = Yup.object({
  [VerizonLoginKeys.USERNAME]: Yup.string().required("Username is required"),
  [VerizonLoginKeys.PASSWORD]: Yup.string().required("Password is required"),
});
